import {AvatarMenuItem} from '@coolcolduk/ui-mui';
import {Box, Drawer} from '@mui/material';
import {User} from '@cp/model';
import NavBarMobileMenuDrawerMenu from './NavBarMobileMenuDrawerMenu';
import NavBarMobileMenuDrawerUser from './NavBarMobileMenuDrawerUser';

export interface NavBarMobileMenuDrawerProps {
  user: User;
  navItems: AvatarMenuItem[];
  userMenu: AvatarMenuItem[];
  isMobileMenuOpen: boolean;
  handleMobileMenuToggle: () => void;
}

export default function NavBarMobileMenuDrawer({
  user,
  navItems,
  userMenu,
  isMobileMenuOpen,
  handleMobileMenuToggle,
}: NavBarMobileMenuDrawerProps) {
  return (
    <Drawer
      data-testid="navbar-mobile-menu-drawer"
      anchor="right"
      open={isMobileMenuOpen}
      onClose={handleMobileMenuToggle}
      sx={{
        '& .MuiDrawer-paper': {
          width: 280,
          backgroundColor: 'background.paper',
          borderLeft: '1px solid',
          borderColor: 'divider',
        },
      }}
    >
      <Box sx={{p: 3}}>
        <NavBarMobileMenuDrawerMenu navItems={navItems} onCloseMenu={handleMobileMenuToggle} />

        {/* Mobile User Section */}
        <NavBarMobileMenuDrawerUser user={user} userMenu={userMenu} onCloseMenu={handleMobileMenuToggle} />
      </Box>
    </Drawer>
  );
}
